import { Component, inject } from '@angular/core';

import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import {
  RdsDialogModule,
  RdsButtonModule,
  RdsFormFieldModule,
  RdsDialogRef,
  RDS_DIALOG_DATA,
  RdsIconsModule,
} from '@rds/angular-components';
import { BUTTON_TEXTS } from '../../../../constants/buttons.constants';
import { ERRORS_TEXTS } from '../../../../constants/errors.contstants';
import { KnowledgeReleaseNote } from '../../../../models/knowledge';
import { urlValidator } from '../../../../validators';
import { RichTextEditorComponent } from '../../../shared/rich-text-editor/rich-text-editor.component';
import { POPUPS } from '../../../../constants/popups.constants';

@Component({
  selector: 'inexp-focus-release-note-dialog',
  imports: [
    ReactiveFormsModule,
    RdsDialogModule,
    RdsButtonModule,
    RdsIconsModule,
    RdsFormFieldModule,
    RichTextEditorComponent,
  ],
  templateUrl: './focus-release-note-dialog.component.html',
  styleUrl: './focus-release-note-dialog.component.scss',
})
export class FocusReleaseNoteDialogComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _dialogRef =
    inject<RdsDialogRef<FocusReleaseNoteDialogComponent>>(RdsDialogRef);
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    releaseNotes?: KnowledgeReleaseNote;
  };
  readonly ERRORS = ERRORS_TEXTS;
  readonly BUTTONS = BUTTON_TEXTS;
  readonly POPUPS = POPUPS;

  form = this._fb.group({
    header: [this.data.releaseNotes?.header ?? '', Validators.required],
    subheader: [this.data.releaseNotes?.subheader ?? '', [Validators.required]],
    description: [
      this.data.releaseNotes?.description ?? '',
      [Validators.required],
    ],
    url: [this.data.releaseNotes?.url ?? '', [urlValidator()]],
    date: [this.data.releaseNotes?.date ?? new Date()],
  });

  submit() {
    if (this.form.valid) {
      this._dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
